import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const decreaseQuantity = (item) => {
    if (item.quantity > 1) {
      handleUpdateQuantity(item.id, item.size, item.color, item.quantity - 1);
    }
  };

  const increaseQuantity = (item) => {
    handleUpdateQuantity(item.id, item.size, item.color, item.quantity + 1);
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <div className="cart-container">
          <div className="empty-cart">
            <h1>Your cart is empty</h1>
            <Link to="/shop" onClick={toTop} className="continue-shopping-link">
              Continue shopping
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <div className="cart-container">
        <h1 className="cart-title">Your Cart</h1>

        <Link to="/shop" onClick={toTop} className="continue-browsing">
          ← CONTINUE BROWSING
        </Link>

        <div className="cart-content">
          <div className="cart-items">
            <div className="cart-header">
              <span className="header-product">Product</span>
              <span className="header-price">Price</span>
              <span className="header-quantity">Quantity</span>
              <span className="header-total">Total</span>
            </div>

            {cartItems.map((item, index) => {
              const product = getProductById(item.id);
              if (!product) return null;

              const itemTotal = parseFloat(product.price) * item.quantity;

              return (
                <div key={index} className="cart-item">
                  <div className="item-product">
                    <div className="item-image-container">
                      <img
                        src={product.image}
                        alt={product.name}
                        className="item-image"
                      />
                    </div>
                    <div className="item-details">
                      <h3 className="item-name">{product.name}</h3>
                      {item.color && (
                        <p className="item-variant">Gold / One size</p>
                      )}
                      <button
                        className="remove-btn"
                        onClick={() =>
                          removeFromCart(item.id, item.size, item.color)
                        }
                      >
                        REMOVE
                      </button>
                    </div>
                  </div>

                  <div className="item-price">${product.price} SGD</div>

                  <div className="item-quantity">
                    <div className="quantity-controls">
                      <button
                        className="qty-btn"
                        onClick={() => decreaseQuantity(item)}
                      >
                        −
                      </button>
                      <span className="qty-value">{item.quantity}</span>
                      <button
                        className="qty-btn"
                        onClick={() => increaseQuantity(item)}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  <div className="item-total">${itemTotal.toFixed(2)} SGD</div>
                </div>
              );
            })}
          </div>

          <div className="cart-sidebar">
            <div className="subtotal-section">
              <span className="subtotal-label">SUBTOTAL</span>
              <span className="subtotal-value">${subtotal.toFixed(2)} SGD</span>
            </div>
            <p className="tax-note">Shipping & taxes calculated at checkout</p>

            <button className="checkout-btn" onClick={handleCheckout}>
              CHECK OUT
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
